import * as R from 'ramda';
import axios from 'axios';

const methods = {
  form: (formData) =>
    axios
      .post('/api/contact/form', formData)
      .then((res) => res?.status === 200),
};

const error = (method) => () => {
  throw new Error(`Unkown method: ${method}`);
};

const main = ({ method, ...rest }) => (methods[method] || error(method))(rest);
R.compose(
  R.forEach(([name, fn]) => (main[name] = fn)),
  R.toPairs,
)(methods);

export default main;
